module.exports = __webpack_public_path__ + "static/img/2_2_1_2.ea15aaa4.jpg";